import React, { useContext } from "react";

import { PLATFORMS } from "../../../../../constants/Platforms";
import { PlatformIcon } from "@dialogueconsulting/sked-ui";
import { cn } from "../../../../../lib/utils";
import { PlatformOptionsCardContext } from "../platform-options-card";

const PLATFORM_LABELS: Record<string, string> = {
  ...Object.fromEntries(
    Object.values(PLATFORMS).map(({ NAME, LABEL }) => [NAME, LABEL])
  ),
  twitter: "X",
  youtubeRedPlay: "YouTube",
};

export const INSTAGRAM_ONLY = ["instagram"];
export const INSTAGRAM_AND_FACEBOOK = ["instagram", "facebook"];

interface PlatformLabelBadgesProps {
  selectedPlatform?: string;
  /** Platform names: `instagram`, `facebook`, `youtubeRedPlay`. */
  platforms: string[];
  className?: string;
  iconClassName?: string;
}

/**
 * Marks a composer field with the platforms it applies to. Only on the linked
 * tab, where one form speaks for several platforms; a platform tab already says
 * which platform it is, and so does a grouped options card.
 */
export const PlatformLabelBadges: React.FC<PlatformLabelBadgesProps> = ({
  selectedPlatform,
  platforms,
  className,
  iconClassName,
}) => {
  const isGroupedByPlatform = useContext(PlatformOptionsCardContext);

  if (selectedPlatform !== "LINKED" || isGroupedByPlatform) return null;

  const unique = [...new Set(platforms.filter(Boolean))];
  if (unique.length === 0) return null;

  return (
    <span className={cn("inline-flex shrink-0 items-center gap-1", className)}>
      {unique.map((type) => (
        <PlatformIcon
          key={type}
          platform={type}
          youtubeRedPlay={type === "youtubeRedPlay"}
          title={PLATFORM_LABELS[type] ?? type}
          className={cn("size-3.5", iconClassName)}
        />
      ))}
    </span>
  );
};
